import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinkalyan() {



  const cardData =
  {
    keyword: 'Cab Service in Kalyan Cab Service ',
    heading: 'Shambhu Cabs: Cab Service in Kalyan Cab Service',
    headingDescription: 'Shambhu Cabs offers reliable Cab Service in Kalyan, providing safe, comfortable, and hassle-free travel for daily commuters, families, corporate travelers, and tourists visiting Kalyan and surrounding areas. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures smooth and convenient rides for local travel, airport transfers, outstation trips, and full-day rentals. With experienced chauffeurs, flexible one-way and round-trip options, doorstep pickup, and 24/7 booking support, Shambhu Cabs makes traveling in and around Kalyan convenient, timely, and stress-free. Whether you are commuting for work, leisure, or special occasions, Shambhu Cabs delivers trusted cab services in Kalyan for comfort, safety, and a reliable travel experience.',

    top: 'Top Places to Visit in Kalyan with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Kalyan Fort",
    "description": "Kalyan Fort is a historic hill fort believed to have origins dating back to the 12th century. It played a strategic role during the rule of the Mughals and Marathas. The fort features old gateways, stone walls, and bastions that showcase medieval military architecture. Visitors can trek up to the fort for panoramic views of Kalyan city and surrounding hills. It is especially popular during monsoon when the greenery enhances the scenic beauty, making it a blend of history, adventure, and nature."
  },
  {
    "title": "Ulhas River",
    "description": "The Ulhas River flows through Kalyan and offers tranquil riverside views and scenic landscapes. It is a great spot for early morning walks, birdwatching, and peaceful photography. Local fishermen and riverside temples add cultural flavor to the experience. During the monsoon, the river swells with rainwater, enhancing its natural beauty and attracting nature enthusiasts to its serene banks."
  },
  {
    "title": "Shri Ganesh Mandir, Kalyan",
    "description": "Shri Ganesh Mandir is one of Kalyan’s most visited temples, dedicated to Lord Ganesha. Known for its spiritual ambiance and colorful celebrations during Ganesh Chaturthi, the temple attracts devotees from across the city. The temple architecture includes traditional Marathi elements, intricate carvings, and well-maintained prayer halls, making it a cultural and spiritual hotspot in Kalyan."
  },
  {
    "title": "Durgadi Fort",
    "description": "Durgadi Fort, also called Durga Devi Fort, is located near Kalyan and is a historical marvel from the medieval period. The fort’s stone walls, hidden passages, and old temples reflect its rich history. Visitors can explore its remnants, enjoy scenic views of surrounding greenery, and learn about the fort’s role in Maratha history. It is a popular destination for trekking enthusiasts and history lovers."
  },
  {
    "title": "Ganesh Mandir, Tembhi Naka",
    "description": "Ganesh Mandir at Tembhi Naka is a prominent temple in Kalyan, attracting devotees daily. Known for its spiritual serenity and colorful festivals, it is a focal point for religious gatherings. The temple area is clean and landscaped, offering peaceful spaces for meditation, prayers, and community rituals. Local fairs during festivals showcase cultural performances and traditional food stalls."
  },
  {
    "title": "Reti Bandar Beach",
    "description": "Reti Bandar Beach is a calm coastal spot near Kalyan where visitors can enjoy sunset views, sand play, and leisure walks. Though less commercialized than other beaches, it offers a serene escape from city life. The beach attracts families, photographers, and nature lovers seeking quiet and scenic coastal beauty, particularly during the evening hours."
  },
  {
    "title": "Vikramgad Lake",
    "description": "Vikramgad Lake is a picturesque water body near Kalyan surrounded by greenery. It is ideal for birdwatching, photography, and evening picnics. The calm waters and peaceful environment make it a relaxing retreat from urban hustle. Monsoon season enhances the lake’s charm with full water levels and lush surroundings, drawing nature enthusiasts to the area."
  },
  {
    "title": "Mahakali Caves",
    "description": "The Mahakali Caves, located a short drive from Kalyan, are ancient Buddhist rock-cut caves dating back to the 1st–3rd century AD. These caves feature stone carvings, monastic cells, and chaityas that highlight early Indian Buddhist architecture. Visitors and history enthusiasts come here to explore the caves, admire inscriptions, and enjoy the tranquil setting amidst nature."
  },
  {
    "title": "Kalyan Museum",
    "description": "Kalyan Museum showcases the cultural and historical heritage of Kalyan and surrounding regions. The museum houses ancient artifacts, sculptures, coins, and exhibits that illustrate the city’s evolution through time. It is an educational spot for students, tourists, and history enthusiasts interested in understanding local traditions, crafts, and heritage."
  },
  {
    "title": "Bhivpuri Waterfall",
    "description": "Bhivpuri Waterfall, located near Kalyan in the lush Western Ghats, is a scenic natural spot especially popular during the monsoon. Surrounded by dense forests and trekking trails, it offers a refreshing escape for adventure seekers, nature lovers, and photographers. Visitors enjoy the cascading water, trekking challenges, and peaceful environment, making it a perfect day-trip destination from Kalyan."
  }
],




"services": [
  {
    "name": "Kalyan Taxi Service",
    "description": "Kalyan Taxi Service provides reliable and comfortable local and outstation taxi services across Kalyan. Ideal for daily commuters, business travelers, and leisure trips, this service ensures punctual pickups, professional drivers, clean and well-maintained vehicles, and safe, hassle-free travel for all passengers."
  },
  {
    "name": "Dombivali Cab Service",
    "description": "Dombivali Cab Service offers efficient and dependable taxi services in and around Dombivali. With experienced chauffeurs, AC and non-AC vehicles, flexible booking options, and 24×7 availability, passengers can enjoy smooth, safe, and timely rides for local, outstation, or airport transfers."
  },
  {
    "name": "Local Cab Kalyan",
    "description": "Local Cab Kalyan provides convenient point-to-point taxi services within Kalyan city. Passengers can book sedans or SUVs for short trips, office commutes, or shopping trips, with professional drivers, transparent fares, and prompt service ensuring a comfortable and reliable local ride."
  },
  {
    "name": "Local Cab Dombivali",
    "description": "Local Cab Dombivali offers hassle-free city rides for residents and visitors. With AC and non-AC cars, safe driving, 24×7 availability, and online booking, this service ensures convenient and comfortable local transportation for daily needs and emergency travel."
  },
  {
    "name": "Affordable Cab Kalyan",
    "description": "Affordable Cab Kalyan provides budget-friendly taxi services without compromising comfort or safety. Ideal for local rides, airport transfers, or outstation trips, this service offers transparent pricing, well-maintained vehicles, and professional drivers for a stress-free travel experience."
  },
  {
    "name": "Affordable Cab Dombivali",
    "description": "Affordable Cab Dombivali delivers cost-effective taxi solutions for both local and outstation trips. Passengers can enjoy clean cars, AC and non-AC options, transparent fares, and punctual service, making it an ideal choice for budget-conscious travelers in Dombivali."
  },
  {
    "name": "24×7 Cab Service Kalyan",
    "description": "24×7 Cab Service Kalyan ensures round-the-clock availability for local and outstation trips. With professional drivers, well-maintained vehicles, and instant online booking, passengers can rely on timely and safe taxi services at any time of day or night."
  },
  {
    "name": "24×7 Cab Dombivali",
    "description": "24×7 Cab Dombivali offers nonstop taxi services for residents and travelers. Whether for airport transfers, business trips, or city commutes, this service provides reliable, safe, and comfortable travel with professional drivers and a variety of vehicle options."
  },
  {
    "name": "Best Cab Kalyan",
    "description": "Best Cab Kalyan provides premium and dependable taxi services in Kalyan. With experienced drivers, clean and comfortable cars, and flexible booking options, passengers can enjoy a smooth, punctual, and secure travel experience for both local and long-distance rides."
  },
  {
    "name": "Best Cab Dombivali",
    "description": "Best Cab Dombivali offers high-quality taxi services for local, outstation, and airport travel. With professional chauffeurs, AC and non-AC options, well-maintained vehicles, and on-time service, this cab service ensures reliable and comfortable transportation for all passengers."
  },
  {
    "name": "Kalyan Outstation Cab",
    "description": "Kalyan Outstation Cab provides long-distance taxi services from Kalyan to nearby cities and tourist destinations. With professional drivers, well-maintained vehicles, competitive pricing, and comfortable rides, passengers can enjoy safe and stress-free outstation travel."
  },
  {
    "name": "Dombivali Outstation Cab",
    "description": "Dombivali Outstation Cab offers dependable long-distance taxi services for travelers heading to nearby cities and popular destinations. With experienced drivers, AC and non-AC cars, and timely service, passengers can enjoy convenient, safe, and comfortable journeys."
  },
  {
    "name": "Kalyan Airport Taxi",
    "description": "Kalyan Airport Taxi ensures smooth and timely airport transfers to and from Kalyan. Passengers can choose from sedans or SUVs, enjoy professional drivers, transparent fares, and 24×7 availability, making travel to Mumbai Airport or nearby airports hassle-free."
  },
  {
    "name": "Dombivali Airport Taxi",
    "description": "Dombivali Airport Taxi provides reliable taxi services for pickups and drops at airports. With well-maintained vehicles, professional chauffeurs, and flexible booking options, passengers can enjoy safe, comfortable, and timely airport transfers."
  },
  {
    "name": "Online Cab Booking Kalyan",
    "description": "Online Cab Booking Kalyan allows passengers to reserve their preferred taxi quickly and easily via app or website. With multiple vehicle options, transparent pricing, and instant confirmation, travelers can enjoy a seamless and convenient taxi booking experience."
  },
  {
    "name": "Online Cab Booking Dombivali",
    "description": "Online Cab Booking Dombivali enables easy and fast reservations for local, outstation, and airport trips. With real-time availability, professional drivers, and a variety of cars, this service ensures a smooth and reliable taxi experience for all passengers."
  },
  {
    "name": "Premium Cab Service Kalyan Dombivali",
    "description": "Premium Cab Service Kalyan Dombivali offers high-end taxi services for luxury, business, and corporate travel. With well-maintained sedans and SUVs, professional chauffeurs, 24×7 availability, and impeccable customer service, passengers can enjoy a comfortable and stress-free ride."
  }
],

"tableData": [
  ["Kalyan Taxi Service", "Dombivali Cab Service"],
  ["Local Cab Kalyan", "Local Cab Dombivali"],
  ["Affordable Cab Kalyan", "Affordable Cab Dombivali"],
  ["24×7 Cab Service Kalyan", "24×7 Cab Dombivali"],
  ["Best Cab Kalyan", "Best Cab Dombivali"],
  ["Kalyan Outstation Cab", "Dombivali Outstation Cab"],
  ["Kalyan Airport Taxi", "Dombivali Airport Taxi"],
  ["Online Cab Booking Kalyan", "Online Cab Booking Dombivali"],
  ["Premium Cab Service Kalyan Dombivali", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Cab Service in Kalyan / Dombivali with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable cab services in Kalyan and Dombivali, perfect for daily commutes, airport transfers, and intercity travel with comfort and safety."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced cabs to enjoy a smooth and comfortable ride across Kalyan and Dombivali."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Local Routes",
    "WhyChoosedescription": "Our professional drivers are well-acquainted with Kalyan and Dombivali routes, ensuring timely, safe, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We provide clear, upfront pricing—fuel, tolls, and driver allowances included—making your cab service in Kalyan and Dombivali stress-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and real-time updates."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for City Travel",
    "WhyChoosedescription": "Choose from hourly, daily, or customized rental plans tailored to your travel needs in Kalyan and Dombivali."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making your travel in Kalyan and Dombivali smooth, comfortable, and worry-free."
  }
]














  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide cab services in Kalyan and Dombivali?',
    answer: 'Yes, Shambhu Cabs offers reliable and comfortable cab services in Kalyan and Dombivali for local travel, airport transfers, and outstation trips.',
  },
  {
    question: 'How can I book a cab in Kalyan or Dombivali with Shambhu Cabs?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team for hassle-free bookings in Kalyan and Dombivali.',
  },
  {
    question: 'What types of vehicles are available for cab services in Kalyan and Dombivali?',
    answer: 'Shambhu Cabs offers a wide range of vehicles including sedans, SUVs, and luxury cars suitable for individual, family, and corporate travel in Kalyan and Dombivali.',
  },
  {
    question: 'Are drivers experienced for cab services in Kalyan and Dombivali?',
    answer: 'Yes, our drivers are licensed, professional, and well-acquainted with the routes in Kalyan and Dombivali to ensure a safe and timely journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for cab services in Kalyan and Dombivali?',
    answer: 'Absolutely. You can select any pickup and drop-off points according to your convenience within Kalyan and Dombivali.',
  },
  {
    question: 'Is cab service available 24x7 in Kalyan and Dombivali?',
    answer: 'Yes, Shambhu Cabs provides round-the-clock cab services in Kalyan and Dombivali to match your travel schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for cab services in Kalyan and Dombivali?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict safety and hygiene protocols to ensure passenger well-being.',
  },
  {
    question: 'What payment options are available for cab services in Kalyan and Dombivali?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments.',
  },
  {
    question: 'Is customer support available during cab journeys in Kalyan and Dombivali?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your cab journey in Kalyan and Dombivali.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Patil',
    feedback: 'Shambhu Cabs made traveling within Kalyan and Dombivali very convenient. The driver was professional, and the car was clean and comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Desai',
    feedback: 'Highly reliable cab service in Kalyan and Dombivali. Shambhu Cabs ensured a smooth and comfortable ride throughout.',
    rating: 5,
  },
];





























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Kalyan and Dombivali",
  "image": "https://www.shambhucab.com/assets/images/kalyan-dombivali-cab.jpg",
  "description": "Shambhu Cabs offers reliable and affordable cab services in Kalyan and Dombivali. Book local, airport, and outstation rides with AC sedans, SUVs, and premium cabs. Available 24×7 for safe, fast, and convenient travel.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/cab-service-kalyan-dombivali"
  }
};






  return (
    <div>
<Helmet>
  <title>Cab Service in Kalyan & Dombivali | Local, Airport & Outstation Cabs | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book reliable cab service in Kalyan and Dombivali with Shambhu Cabs. Local, airport, and outstation cabs available 24×7. Affordable, safe, and premium rides in sedans and SUVs."
  />

  <meta
    name="keywords"
    content="Kalyan Taxi Service, Dombivali Cab Service, Local Cab Kalyan, Local Cab Dombivali, Affordable Cab Kalyan, Affordable Cab Dombivali, 24×7 Cab Service Kalyan, 24×7 Cab Dombivali, Best Cab Kalyan, Best Cab Dombivali, Kalyan Outstation Cab, Dombivali Outstation Cab, Kalyan Airport Taxi, Dombivali Airport Taxi, Online Cab Booking Kalyan, Online Cab Booking Dombivali, Premium Cab Service Kalyan Dombivali"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/43.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinkalyan;